var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 1.29955C19.48 1.80955 18.58 2.17955 17.63 2.37955C17.241 1.95106 16.7685 1.60653 16.2416 1.3671C15.7148 1.12766 15.1445 0.998365 14.5659 0.987129C13.9872 0.975894 13.4124 1.08296 12.8766 1.30176C12.3408 1.52056 11.8554 1.84648 11.45 2.25955C10.646 3.06328 10.1929 4.1527 10.19 5.28955C10.19 5.62955 10.23 5.95955 10.27 6.28955C8.56715 6.19381 6.90329 5.74208 5.38582 4.96354C3.86834 4.18499 2.53096 3.09692 1.46 1.76955C1.08835 2.42438 0.875962 3.15746 0.84 3.90955C0.848924 4.6194 1.02793 5.31676 1.362 5.94315C1.69608 6.56954 2.17548 7.10669 2.76 7.50955C2.08805 7.48444 1.4324 7.29564 0.85 6.95955V7.02955C0.85 9.08955 2.32 10.8296 4.29 11.2396C3.92 11.3196 3.55 11.3696 3.14 11.3896L2.38 11.3196C2.65397 12.1676 3.18351 12.9102 3.89603 13.4454C4.60856 13.9807 5.46921 14.2826 6.36 14.3096C4.81582 15.4786 2.93669 16.1201 1 16.1396L0 16.0796C1.97191 17.3358 4.26193 18.002 6.6 17.9995C14.48 17.9995 18.8 11.4496 18.77 5.81955C18.79 5.58955 18.79 5.40955 18.77 5.19955C19.6241 4.60222 20.3543 3.8449 20.92 2.96955C20.15 3.33955 19.32 3.56955 18.47 3.66955C19.3627 3.13802 20.0204 2.28737 20.31 1.28955",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.5de92974108f200405da6d8ed49a998e.svg";
export { ForwardRef as ReactComponent };